// All freak contexts, in display order (mirrors api FreakContextEnum)
export const ALL_CONTEXTS = [
  'wof',
  'bike',
  'fishing',
  'trip',
  'fit',
  'running',
  'dogs',
  'games',
  'books',
  'food',
  'shopping',
  'tech',
  'motorization',
  'gardening',
  'music',
  'sport',
  'winterSports',
  'horseRiding',
  'movies',
  'series',
  'skateboard',
  'inlineSkate',
  'scooter',
  'bmx',
  'mushroom',
  'nordicWalking',
];

// Contexts shown in the switcher: the user's chosen ones (empty = all), always incl. the current one
export const getVisibleContexts = (currentUser, currentContext) => {
  const chosen = currentUser?.visibleContexts || [];
  if (!chosen.length) {
    return ALL_CONTEXTS;
  }
  return ALL_CONTEXTS.filter(c => chosen.includes(c) || c === currentContext);
};
